export enum QueryParams {
    tab = 'tab',
    page = 'page',
    orderby = 'orderby',
    orderbydirection = 'orderbydirection',
    search = 'textSearch',
    instruments = 'Instruments',
    genres = 'Genres',
    type = 'Type',
    bpmLow = 'BpmLowerBound',
    bpmUp = 'BpmUpperBound',
    key = 'KeyRootNote',
    keySign = 'KeySign',
    keyQuality = 'KeyQuality',
}
